import { Meta } from "../PropertyPanel/types";

export const BUSINESS_SETTER_MAPPINGS: Record<string, Meta> = {
  // 颜色选择器
  colorPicker: {
    setters: {
      props: [
        {
          name: "_colorSelect",
          title: "预设颜色",
          setter: "select",
          // options: (parentConfig: any) => parentConfig.options || [], // 从父配置获取预设颜色选项
          options: [
            {
              label: "Background",
              value: "var(--background-color)",
            },
            {
              label: "Dark",
              value: "#000000",
            },
            {
              label: "Light",
              value: "#ffffff",
            },
            {
              label: "Primary",
              value: "var(--primary-color)",
            },
            {
              label: "Secondary",
              value: "var(--secondary-color)",
            },
          ],
          effects: {
            dependencies: ["_colorCustom"],
            handler: "handleColorSelectChange",
            params: {
              _colorCustom: { var: "_colorCustom" },
            },
            updateStrategy: {
              when: ["_colorCustom"],
              keepFields: [],
            },
          },
        },
        {
          name: "_colorCustom",
          title: "自定义颜色",
          setter: "color",
          effects: {
            dependencies: ["_colorSelect"],
            handler: "handleColorCustomChange",
            params: {
              _colorSelect: { var: "_colorSelect" },
            },
            updateStrategy: {
              when: ["_colorSelect"],
              keepFields: [],
            },
          },
        },
      ],
      layout: [
        {
          name: "themeColor",
          title: "主题色",
          fields: ["setters/props/_colorSelect", "setters/props/_colorCustom"],
        },
      ],
    },
    transforms: {
      handleColorSelectChange: {
        getValues: (params: any) => {
         return params._colorCustom
        },
      },
      handleColorCustomChange: {
        getValues: (params: any) => {
          return params._colorSelect
        },
      },
    },
    defaultValues: {
      props: {
        _colorSelect: "#000000",
        _colorCustom: "#000000",
      },
    },
  },

  // 数字输入
  // numberRange: {
  //   atomic: [
  //     {
  //       name: '_numberInput',
  //       title: '数值输入',
  //       setter: 'number',
  //       min: 0,
  //       max: 100,
  //     },
  //     {
  //       name: '_numberSlider',
  //       title: '滑动输入',
  //       setter: 'number',
  //       variant: 'slider',
  //       min: 0,
  //       max: 100,
  //     }
  //   ],
  //   transform: {
  //     in: (value) => ({
  //       _numberInput: value,
  //       _numberSlider: value
  //     }),
  //     out: (values) => values._numberInput
  //   }
  // },

  // JSON编辑器
  // jsonEditor: {
  //   atomic: [
  //     {
  //       name: '_jsonPreview',
  //       title: 'JSON预览',
  //       setter: 'string',
  //     },
  //     {
  //       name: '_jsonEdit',
  //       title: 'JSON编辑',
  //       setter: 'json',
  //     }
  //   ],
  //   transform: {
  //     in: (value) => ({
  //       _jsonPreview: JSON.stringify(value, null, 2),
  //       _jsonEdit: value
  //     }),
  //     out: (values) => {
  //       try {
  //         return JSON.parse(values._jsonEdit);
  //       } catch {
  //         return values._jsonEdit;
  //       }
  //     }
  //   }
  // }
};
